import { render, staticRenderFns } from "./LangFlag.vue?vue&type=template&id=845f0d9e&scoped=true&"
import script from "./LangFlag.vue?vue&type=script&lang=js&"
export * from "./LangFlag.vue?vue&type=script&lang=js&"
import style0 from "./LangFlag.vue?vue&type=style&index=0&id=845f0d9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845f0d9e",
  null
  
)

export default component.exports